/**
 * Aktualisiert Seitentitel, Meta-Tags und Link-Tags im <head>.
 * Wenn ein Wert leer ist ("", null, undefined), wird das Tag gelöscht.
 *
 * @param {string} [title] - Der neue Seitentitel
 * @param {Object} [metaTags] - Key-Value-Paare für Meta-Tags (name/property -> content)
 * @param {Object} [linkTags] - Key-Value-Paare für Link-Tags (rel -> href)
 */
export function setPageMeta(title = '', metaTags = {}, linkTags = {}) {
  if (title) document.title = title + ' | Lektüren verstehen';
  else document.title = 'Lektüren verstehen';

  // 2. Meta-Tags setzen, aktualisieren oder löschen
  Object.entries(metaTags).forEach(([name, content]) => {
    const element = document.querySelector(`meta[name="${name}"], meta[property="${name}"]`);

    // Wert ist leer -> bestehendes Tag entfernen
    if (!content && content !== 0) {
      if (element) element.remove();
      return;
    }

    // Wert vorhanden -> Tag anlegen oder aktualisieren
    if (!element) {
      const newMeta = document.createElement('meta');
      if (name.startsWith('og:')) {
        newMeta.setAttribute('property', name);
      } else {
        newMeta.setAttribute('name', name);
      }
      newMeta.setAttribute('content', content);
      document.head.appendChild(newMeta);
    } else {
      element.setAttribute('content', content);
    }
  });

  // 3. Link-Tags setzen, aktualisieren oder löschen
  Object.entries(linkTags).forEach(([rel, href]) => {
    const element = document.querySelector(`link[rel="${rel}"]`);

    // Wert ist leer -> bestehendes Tag entfernen
    if (!href) {
      if (element) element.remove();
      return;
    }

    // Wert vorhanden -> Tag anlegen oder aktualisieren
    if (!element) {
      const newLink = document.createElement('link');
      newLink.setAttribute('rel', rel);
      newLink.setAttribute('href', href);
      document.head.appendChild(newLink);
    } else {
      element.setAttribute('href', href);
    }
  });
}
